import React from 'react';
import { change, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';

import UpdateAuditC from '../../../Actions/Register/updateAuditC';
import iphoneImg from '../../../images/iphone-mylivewell.png';
import portfolioImg from '../../../images/portfolio-image.png';
import benefitIcon1Img from '../../../images/benefit-icon-1.svg';
import benefitIcon2Img from '../../../images/benefit-icon-2.svg';
import benefitIcon3Img from '../../../images/benefit-icon-3.svg';
import benefitIcon4Img from '../../../images/benefit-icon-4.svg';

// const validate = (values) => {
//   if (!document.cookie.split(';').filter((item) => item.includes('gdprpolicy=accepted')).length) {
//     document.querySelector('.js-comb-register').click();
//   }
// };

class Page1 extends React.PureComponent {
  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }

    // check localstorage
    if (localStorage.getItem('personalInfo') !== null) {
      const storagePersonalData = JSON.parse(localStorage.getItem('personalInfo'));

      storagePersonalData.linkBack = true;
      localStorage.setItem('personalInfo', JSON.stringify(storagePersonalData));
      // const storagePersonalData = { activity: 3, weight: 12.7, height: 60.96, units: 0, smokingamount: '0', gender: 'Male' };

      this.props.dispatch(change('registration', 'client[gender]', storagePersonalData.gender));
      this.props.dispatch(change('registration', 'assessment[activity_times]', storagePersonalData.activity.toString()));
      this.props.dispatch(change('registration', 'assessment[weight_weight]', storagePersonalData.weight.toString()));
      this.props.dispatch(change('registration', 'assessment[weight_height]', storagePersonalData.height.toString()));
      if (parseInt(storagePersonalData.smokingamount, 10) > 0) {
        this.props.dispatch(change('registration', 'assessment[smoking]', 'Yes'));
        this.props.dispatch(change('registration', 'assessment[smoking_quantity]', storagePersonalData.smokingamount));
      } else {
        this.props.dispatch(change('registration', 'assessment[smoking]', 'No'));
      }
      this.props.dispatch(change('registration', 'assessment[alcohol_units_per_week]', storagePersonalData.units.toString()));
      this.props.dispatch(UpdateAuditC('units_per_week', storagePersonalData.units.toString()));
    }
  }

  render() {
    return (
      <div className="page-1" ref={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <div className="justifycentre register-block ready-start">
          <Heading tag="h1" classes="header-text smaller"><span id="register1">Register now to get help and support</span></Heading>
          <Paragraph classes="larger">Complete our lifestyle assessment to register and discover how we can support you.</Paragraph>

          <Heading tag="h3" classes="header-text purple">The benefits of registering</Heading>
          <div className="flex-row four-cols smaller-spacing benefit-list">
            <div className="col">
              <div className="benefit-icon-container">
                <img src={benefitIcon1Img} alt="coaching icon" width="54" height="51" />
              </div>
              <Paragraph classes="benefit-title-text">Behaviour change coaching</Paragraph>
              <Paragraph>Health coaching from your <br/>very own LiveWell Coach</Paragraph>
            </div>
            <div className="col">
              <div className="benefit-icon-container">
                <img src={benefitIcon2Img} alt="LiveWell icon" width="70" height="41" />
              </div>
              <Paragraph classes="benefit-title-text">My <br/>LiveWell</Paragraph>
              <Paragraph>Personalised tips and tools <br/>to LiveWell</Paragraph>
            </div>
            <div className="col">
              <div className="benefit-icon-container">
                <img src={benefitIcon3Img} alt="partner icon" width="50" height="50" />
              </div>
              <Paragraph classes="benefit-title-text">Partner <br/>Introductions</Paragraph>
              <Paragraph>Introductions to <br/>partner services</Paragraph>
            </div>
            <div className="col">
              <div className="benefit-icon-container">
                <img src={benefitIcon4Img} alt="vouchers icon" width="50" height="40" />
              </div>
              <Paragraph classes="benefit-title-text">Vouchers and <br />more</Paragraph>
              <Paragraph>Find out if your eligible <br/>for kick-start vouchers</Paragraph>
            </div>
          </div>
          <Paragraph classes="button-groups">
            <Button classes={['color-button']} label="Get started" onClick={this.props.onSubmit} />
          </Paragraph>
        </div>

        <div className="register-block">
          <div className="flex-row two-cols large-spacing">
            <div className="col">
              <Heading classes="header-text smallest">Three steps to register</Heading>
              <div className="step-list">
                <div className="step-list-item">
                  <Heading classes="header-text xsmaller">1</Heading>
                  <div className="step-detail">
                    <p className="step-detail-title" data-count="1">The legal stuff</p>
                    <Paragraph>Why we ask for certain info and how we securely store your data</Paragraph>
                  </div>
                </div>
                <div className="step-list-item">
                  <Heading classes="header-text xsmaller">2</Heading>
                  <div className="step-detail">
                    <p className="step-detail-title" data-count="2">About you</p>
                    <Paragraph>Who you are and where you come from</Paragraph>
                  </div>
                </div>
                <div className="step-list-item">
                  <Heading classes="header-text xsmaller">3</Heading>
                  <div className="step-detail">
                    <p className="step-detail-title" data-count="3">About Your Lifestyle</p>
                    <Paragraph>Questions about your health, AKA – the nitty-gritty <span role="img" aria-label="thumb up emoji" style={{ fontFamily: 'Segoe UI Emoji' }}>&#128077;</span></Paragraph>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <Heading classes="header-text smallest">{"What's"} your goal?</Heading>
              <Paragraph>We’re going to ask you questions relating to your weight; physical activity, alcohol and smoking. ‘Why?’ I hear you ask; ‘when I just want to lose weight or quit smoking’. We’re an integrated lifestyle service, so, if your goal is to lose weight, we also want to help you take steps to become more active which will with your weight loss goal. We’ll ask if you do or do not want each type of support. <span className="highlight">The choice is yours.</span></Paragraph>
            </div>
          </div>
        </div>

        {/* <div className="register-block expanded mylivewell">
          <div className="expanded-bg" />
          <div className="expanded-content">
            <Heading classes="header-text smaller">My LiveWell</Heading>
            <Paragraph classes="larger">We’ll provide you with your own profile called My LiveWell with tools, tips and tricks to work towards your goal. Login to update your progress any time. We’ll hold you to account through regular check-ins to hear how you’re doing, and how we can help.</Paragraph>
            <img className="iphone-image" src={iphoneImg} alt="my livewell iphone screenshot" width="263.76" height="530" />
          </div>
        </div> */}

        <div className="register-block">
          <div className="flex-row two-cols large-spacing align-items-center">
            <div className="col">
              <Heading classes="header-text smallest">We’re a free service <br /> for any adult in Dorset</Heading>
              <Paragraph>Why is it free? We’re part of Our Dorset: your local council and NHS services working together. LiveWell is a public health service called Public Health Dorset. We support our NHS colleagues by helping adults in Dorset take steps to healthy living. To date, <span>we’ve helped more than 30,000 people</span>. Our local team of advisors and coaches are ready to help you too.</Paragraph>
            </div>
            <div className="col">
              <div className="quote-block">
                <img src={portfolioImg} alt="quote author" />
                <Heading tag="h3" classes="header-text purple">“It really feels like {"we're"} making a difference by giving support to local people in our fabulous county.”</Heading>
                <Paragraph classes="larger quote-author">Natalie</Paragraph>
                <Paragraph classes="quote-jobtitle">LiveWell Dorset Advisor</Paragraph>
              </div>
            </div>
          </div>
        </div>

        <div className="justifycentre register-block green">
          <Heading classes="header-text smaller">Ready to start?</Heading>
          <Paragraph classes="larger">{"We're"} ready to help! {"Let's"} get you registered.</Paragraph>
          <Paragraph classes="button-groups">
            <Button classes={['color-button outline white']} label="Next step" onClick={this.props.onSubmit} />
          </Paragraph>
        </div>
      </div>
    );
  }
}

Page1.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Page1);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/Page1.jsx